/**
 * Date format constants used across the application
 */

export const DATE_FORMAT = {
  IO_FORMAT: "YYYY-MM-DD",
  DISPLAY_FORMAT: "DD/MM/YYYY",
};

export const DATETIME_FORMAT = {
  IO_FORMAT: "YYYY-MM-DD HH:mm:ss",
  DISPLAY_FORMAT: "DD/MM/YYYY HH:mm",
};
